import { EventType } from '@tencent/chart/lib/antv/g2/interface';

export const CHART_EVENT_MAP = {
    onMouseDown: EventType.MOUSEDOWN,
    onMouseUp: EventType.MOUSEUP,
    onMouseMove: EventType.MOUSEMOVE,
    onMouseEnter: EventType.MOUSEENTER,
    onMouseLeave: EventType.MOUSELEAVE,
    onDoubleClick: EventType.DBLCLICK,
};
